module.exports = __webpack_public_path__ + "static/img/gpt7.09f2fbeb.jpg";